import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ContentWrapper(props) {
    const location = useLocation()

    // close side nav when click on body
    // this action is trigger when screen size less than medium
    const sideNavCloseOnBodyOnClick = e => {
        if (window.getComputedStyle(document.getElementById("layoutSidenav_content"), ':before').width != "auto" && window.getComputedStyle(document.getElementById("layoutSidenav_content"), ':before').width != "100%") {
            document.body.classList.toggle('sb-sidenav-toggled');
            localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
        }
    }

    useEffect(() => {
        sideNavCloseOnBodyOnClick()
    }, [location])
    return (
        <>
            {/*other content*/}
            <div id="layoutSidenav_content" onClick={sideNavCloseOnBodyOnClick} >
                {props.children}
            </div >
        </>
    );
}

export default ContentWrapper;